import { useState, useEffect } from 'react';
import endpointsJson from './endpoints.json';

export const useApiEndpoints = () => {
  const loadInitialEndpoint = () => {
    const isOnlyOneEndpointEnabled = () => 
      endpointsJson.reduce((count, endpoint) => count + (endpoint.isEnabled ? 1 : 0), 0) === 1;
    const savedEndpoint = localStorage.getItem('selectedEndpoint');
    const defaultEndpoint = endpointsJson.find(e => e.default && e.isEnabled);
    return isOnlyOneEndpointEnabled() ? defaultEndpoint!.name : savedEndpoint!;
  };

  const [selectedEndpoint, setSelectedEndpoint] = useState<string>(loadInitialEndpoint());

  useEffect(() => {
    localStorage.setItem('selectedEndpoint', selectedEndpoint);
  }, [selectedEndpoint]);

  const availableEndpoints = endpointsJson.filter(e => e.isEnabled).map(e => e.name);

  const setApiEndpoint = (endpointName: string) => {
    if (availableEndpoints.includes(endpointName)) {
      setSelectedEndpoint(endpointName);
    } else {
      throw new Error("Attempted to set an unavailable API endpoint");
    }
  };

  return {
    availableEndpoints,
    selectedEndpoint,
    setApiEndpoint,
  };
};